<script setup lang="ts">
  import { cva } from 'class-variance-authority'
  type ButtonGroupItem = string | { key: string; title: string }
  defineProps<{ items: ButtonGroupItem[]; active?: string }>()
  const emits = defineEmits<{
    click: [value: string]
  }>()

  const getItemKey = (item: ButtonGroupItem) => (typeof item === 'string' ? item : item.key)
  const getItemTitle = (item: ButtonGroupItem) => (typeof item === 'string' ? item : item.title)

  const buttonClasses = cva(
    'rounded-full px-3 py-2 text-bt-blue-dark flex items-center justify-center whitespace-nowrap shrink-0 sm:grow sm:shrink text-subtitle-2',
    {
      variants: {
        active: {
          true: 'bg-white shadow-sm',
          false: 'bg-gray'
        }
      },
      defaultVariants: {
        active: false
      }
    }
  )
</script>

<template>
  <div class="flex w-max shrink-0 flex-row items-center gap-2 rounded-full bg-grey p-2 sm:w-full sm:shrink">
    <button
      v-for="item in items"
      :key="getItemKey(item)"
      type="button"
      :aria-pressed="active === getItemKey(item)"
      :class="buttonClasses({ active: active === getItemKey(item) })"
      @click="emits('click', getItemKey(item))"
    >
      {{ getItemTitle(item) }}
    </button>
  </div>
</template>
